export default __webpack_public_path__ + "static/media/cylinderpreview.f8daced7.png";